module.exports = __webpack_public_path__ + "static/media/funnel_test.ba5249b0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/funnel_test.mp4
// module id = 692
// module chunks = 0